import script from "./SiteSettingsAdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteSettingsAdminView.vue?vue&type=script&setup=true&lang=js"

import "./SiteSettingsAdminView.vue?vue&type=style&index=0&id=e3b2312a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3b2312a"]])

export default __exports__